import { render, staticRenderFns } from "./DropList.vue?vue&type=template&id=455e5bc8&scoped=true&"
import script from "./DropList.vue?vue&type=script&lang=js&"
export * from "./DropList.vue?vue&type=script&lang=js&"
import style0 from "./DropList.vue?vue&type=style&index=0&id=455e5bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455e5bc8",
  null
  
)

export default component.exports